export default {
  computed: {
    /**
     * Access the global App object.
     */
    App () {
      return window.App
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/mixins/initial-state.js